<template>
    <div class="c-page-wapper">
        <div class="page-top-nav"><Nav /></div>
        <div class="page-content">
            <slot></slot>
        </div>
        <div class="page-bottom"><Footer /></div>
    </div>
</template>

<script>
import Nav from "./Nav.vue";
import Footer from "./Footer.vue";
export default {
    name: "PageWapper",
    components: { Nav, Footer },
};
</script>

<style scoped lang="less">
.c-page-wapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    .page-top-nav {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 99;
    }
    .page-content {
        flex: 1;
        padding-top: 80px;
        overflow: auto;
    }
}
</style>
